const YM_ID = 103410368

export function useYandexMetrika() {
	const reachGoal = (goalId: string) => {
		if (typeof window !== 'undefined' && (window as any).ym) {
			;(window as any).ym(YM_ID, 'reachGoal', goalId)
		}
	}

	return {
		reachGoal,
	}
}
